import { render } from "./PetPersonality.vue?vue&type=template&id=2baf06e9&scoped=true"
import script from "./PetPersonality.vue?vue&type=script&lang=js"
export * from "./PetPersonality.vue?vue&type=script&lang=js"

import "./PetPersonality.vue?vue&type=style&index=0&id=2baf06e9&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2baf06e9"]])

export default __exports__